import { useEffect, useState } from "react";
import styled from "styled-components";
import Input from "../../sharedUI/Input";
import Button from "../../sharedUI/Button";
import Checkbox from "../../sharedUI/Checkbox";
import FileInput from "../../sharedUI/FileInput";
import TagsInput from "../../sharedUI/TagsInput";

const StyledMusicForm = styled.div`
  form {
    max-width: 600px;
  }
`;

const MusicForm = ({ handleSubmit, data, outlet }) => {
  const initialData = {
    title: "",
    published: false,
    file: null,
    tags: [],
  };

  const [formData, setFormData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    handleSubmit(
      formData,
      () => {
        setFormData(initialData);
        setLoading(false);
      },
      () => setLoading(false)
    );
  };

  useEffect(() => {
    if (data) setFormData(data);
  }, [data]);

  return (
    <StyledMusicForm>
      <form onSubmit={onSubmit}>
        <Checkbox
          className="mbottom1"
          label="Publicerad"
          checked={formData.published}
          onChange={(e) =>
            setFormData({
              ...formData,
              published: e.target.checked,
            })
          }
        />

        <Input
          label="Filens namn"
          type="text"
          value={formData.title}
          name="title"
          placeholder="Namn"
          required
          disabled={loading}
          onChange={handleChange}
        />

        <TagsInput
          label="Taggar"
          value={formData.tags}
          onChange={handleChange}
          name="tags"
        />

        <FileInput
          type="audio"
          value={formData.file}
          onChange={handleChange}
          name="file"
          outlet={outlet}
          label="Musikfil"
        />

        <div className="flex jce">
          <Button type="submit" disabled={loading}>
            {loading ? "Sparar..." : "Spara"}
          </Button>
        </div>
      </form>
    </StyledMusicForm>
  );
};

export default MusicForm;
